import { Modal, IconButton, TextField, ButtonGroup, Button } from '@nike/eds';
import { useState } from 'react';

export default function DictionaryItemNew({
  onCreateFn,
  error,
  status,
}: {
  onCreateFn: (data: DictionaryTermPayload) => void;
  error: string;
  status: string;
}) {
  const [visible, setVisible] = useState(false);
  const [textValue, setTextValue] = useState('');
  const [errMessage, setErrMessage] = useState('');
  const resetModal = () => {
    setTextValue('');
    setErrMessage('');
  };
  const onOpenModal = () => {
    setVisible(true);
    resetModal();
  };
  const onSubmitBtnClick = () => {
    onCreateFn({
      term: textValue,
    });
    onCloseModal();
  };
  const onCloseModal = () => {
    setVisible(false);
  };

  return (
    <>
      <div className='tw-fixed tw-bottom-10 tw-right-20'>
        <IconButton icon='Plus' label='New' onClick={onOpenModal} />
      </div>
      <Modal
        onDismiss={onCloseModal}
        isOpen={visible}
        headerSlot={'New Dictionary Term'}
      >
        <div className='tw-flex tw-flex-col tw-justify-center'>
          <div className='tw-mb-10'>
            <TextField
              type='text'
              value={textValue}
              onChange={(event) => {
                const { target } = event;
                const val = (target as HTMLInputElement).value;
                setTextValue(val);
              }}
              id='dictionary-new-item'
              hasErrors={errMessage != ''}
              errorMessage={errMessage}
              placeholder='term'
              label=''
              subtitle=''
            />
          </div>
          <ButtonGroup>
            <Button
              onClick={onSubmitBtnClick}
              size='small'
              variant='secondary'
              className='eds-background--green-60 eds-color--white eds-border--green-60'
            >
              Submit
            </Button>
            <Button onClick={onCloseModal} size='small' variant='secondary'>
              Cancel
            </Button>
          </ButtonGroup>
        </div>
      </Modal>
    </>
  );
}
